import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { CatalogOrigin } from "@KassaroAB/shared/types/enums/CatalogOrigin";
import colors from "@styling/colors";
import { borderRadius, spacing } from "@styling/sizing";
import { fontSizes } from "@styling/fonts";

const Chip = styled.span<{ $chain: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  border-radius: ${borderRadius.small}px;
  font-size: ${fontSizes.small}px;
  font-weight: 700;
  line-height: 1;
  background-color: ${({ $chain }) =>
    $chain ? colors.infoBackground : colors.backgroundDark};
  color: ${({ $chain }) => ($chain ? colors.infoText : colors.textMuted)};
`;

type CatalogOriginChipProps = {
  origin?: CatalogOrigin;
};

export const CatalogOriginChip = ({ origin }: CatalogOriginChipProps) => {
  const { t } = useTranslation();
  const resolved = origin ?? CatalogOrigin.STORE;
  const isChain = resolved === CatalogOrigin.CHAIN;

  return (
    <Chip
      $chain={isChain}
      aria-label={t(`catalogOrigin.${resolved}`)}
      title={t(`catalogOrigin.${resolved}`)}
    >
      {t(`catalogOriginShort.${resolved}`)}
    </Chip>
  );
};

export const CatalogListName = ({
  name,
  origin,
  showOrigin,
}: {
  name: string;
  origin?: CatalogOrigin;
  showOrigin: boolean;
}) => {
  if (!showOrigin) {
    return <>{name}</>;
  }

  return (
    <NameRow>
      <CatalogOriginChip origin={origin} />
      <NameText>{name}</NameText>
    </NameRow>
  );
};

const NameRow = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${spacing.x1}px;
  min-width: 0;
  max-width: 100%;
`;

const NameText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
`;
